<script setup name="TvbSvgIcon">
/** svgicon圖標 */
import { computed } from 'vue'

const props = defineProps({
    prefix: {
        type: String,
        default: 'icon'
    },
    name: {
        type: String,
        required: true
    },
    color: {
        type: String,
        default: ''
    }
})

const symbolId = computed(() => `#${props.prefix}-${props.name}`)
</script>

<template>
    <svg class="svg-icon" aria-hidden="true" :style="{ color }">
        <use :xlink:href="symbolId" :fill="color" />
    </svg>
</template>

<style scoped>
.svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: middle;
}
</style>
